export default {
    slug: 'tickets/templates',
    title: 'PDF Ticket Templates',
    visible: [
        'name',
    ],
    listview: 'TicketTemplateListView',
    locales: ['common'],
    columns: [
        {
            key: 'name',
            label: 'Name',
            main: true,
        }
    ],
    actions: {
        details: {
            title: 'Details',
            level: 'row',
            vm: 'goToDetails'
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/store/tickets/templates/state.js